<script>
import { mapActions } from "vuex";
import Nav from "./Nav.vue";
export default {
  components: { Nav },
  async mounted() {
    await this.getProperties(this.$store.state.userRoot.id);
  },
  methods: {
    ...mapActions("property", ["getProperties"]),
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    paddingClass() {
      if (['ReservationCalendar', 'hotelReservationCalendar', 'hourlyCalendar', 'monthlyCalendar', 'availabilityPrices'].includes(this.routeName)) {
        return 'no-padding-inline';
      }
      return '';
    },
    paddingStyle() {
      if (this.routeName === 'manageChatBot') {
        return { 'padding-inline': '8%', 'background': '#f8f9fa !important' };
      }
      return {};
    }
  },
};
</script>

<template>
  <div>
    <Nav />

    <div
      :class="['maqueta-create', 'contenedor-main', 'contenedor-full', paddingClass]"
      :style="paddingStyle"
    >
      <div class="container-fluid p-0">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<!-- OJO: este <style> NO es scoped (las reglas afectan a toda la app). `.contenedor-main`
     es la clase del contenedor de TODOS los layouts, así que estas reglas se colaban en
     el panel principal (Maqueta) y le pisaban su padding real (izq 8% / der 2%) con un
     18% centrado — de ahí los márgenes laterales enormes en pantallas grandes, y que a
     veces se vieran y otras no según el orden en que se inyectan los estilos. Se acotan
     con `.maqueta-create`, la clase propia de ESTE layout. -->
<style lang="scss">
.maqueta-create.contenedor-main {
  padding-top: 65px !important;
  width: 100%;

  @media (min-width: 1450px) {
    padding-inline: 18% !important;
  }
}

.maqueta-create.no-padding-inline {
  padding-inline: 0 !important;
}

@media (min-width: 768px) {
  .maqueta-create.contenedor-full {
    text-align: left;
    margin: auto;
  }
}
</style>